import axios from 'axios';
import {
  CartAttributes,
  CategoryAttributes,
  ProductAttributes,
  UiActionsAttributes,
  UserAttributes,
} from '@italist/grpc-proto/services/guardian_pb';
import { getClientInfo } from './data/getClientInfo';
import * as datadog from '../datadog/datadog';

/* Interfaces */
export interface TrackEventPayload {
  cart?: Partial<CartAttributes.AsObject>;
  categoryDepartment?: Partial<CategoryAttributes.AsObject>;
  event: string;
  product?: Partial<ProductAttributes.AsObject>;
  ui?: Partial<UiActionsAttributes.AsObject>;
  user?: Partial<UserAttributes.AsObject>;
}

const callTrackingApi = (payload: Partial<TrackEventPayload> = { event: '' }): void => {
  datadog.logEvent(payload.event);
  setTimeout(() => {
    axios.post('/api/tracking/', {
      ...payload,
      commons: getClientInfo(),
    });
  }, 0);
};

export const track = async (eventType: string, payload: Partial<TrackEventPayload> = {}): Promise<void> =>
  callTrackingApi({ event: eventType, ...payload });
